<template>
    <div class="pet-ct-training">
      <!-- 01 顶部导航栏 -->
      <header class="fixed top-0 left-0 right-0 z-50 glass-nav border-b border-gray-100">
        <div class="container-custom h-20 flex items-center justify-between">
          <div class="flex items-center gap-4">
            <div class="flex items-center gap-2">
              <div class="w-10 h-10 bg-brand-blue-600 rounded-lg flex items-center justify-center">
                <i data-lucide="shield-check" class="text-white w-6 h-6"></i>
              </div>
              <div class="flex flex-col">
                <span class="text-xl font-bold text-brand-blue-900 tracking-tight">宠医客</span>
                <span class="text-xs text-gray-500 font-medium">宠物CT影像实训系统</span>
              </div>
            </div>
          </div>
  
          <nav class="hidden lg:flex items-center gap-8">
            <a href="#intro" class="text-gray-600 hover:text-brand-blue-600 font-medium transition-colors">产品介绍</a>
            <a href="#features" class="text-gray-600 hover:text-brand-blue-600 font-medium transition-colors">功能亮点</a>
            <a href="#users" class="text-gray-600 hover:text-brand-blue-600 font-medium transition-colors">适用人群</a>
            <a href="#pricing" class="text-gray-600 hover:text-brand-blue-600 font-medium transition-colors">价格方案</a>
            <a href="#faq" class="text-gray-600 hover:text-brand-blue-600 font-medium transition-colors">常见问题</a>
          </nav>
  
          <div class="flex items-center gap-4">
            <button @click="handleClick" class="bg-brand-blue-600 text-white px-6 py-2.5 rounded-full font-semibold hover:bg-brand-blue-700 transition-all shadow-md shadow-brand-blue-200">
              立即购买
            </button>
          </div>
        </div>
      </header>
  
      <!-- 02 首屏 Banner -->
      <section id="intro" class="pt-32 pb-20 hero-gradient overflow-hidden">
        <div class="container-custom">
          <div class="flex flex-col lg:flex-row items-center gap-12">
            <!-- 左侧文案 -->
            <div class="w-full lg:w-[55%]">
              <div class="inline-flex items-center gap-2 bg-brand-blue-50 text-brand-blue-600 px-4 py-1.5 rounded-full text-sm font-bold mb-6">
                <span class="relative flex h-2 w-2">
                  <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                  <span class="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
                </span>
                2024 年度全新宠物医学实训产品
              </div>
              <h1 class="text-5xl lg:text-6xl font-black text-brand-blue-900 mb-6 leading-tight">
                宠物CT影像<br/>实训系统
              </h1>
              <p class="text-2xl text-gray-700 font-semibold mb-6">在线完成CT扫描操作、病历阅片与诊断报告训练</p>
              <p class="text-lg text-gray-500 leading-relaxed mb-8">
                面向宠物医生、影像科医生、实习医生及教学机构,提供宠物CT检查流程实训与影像诊断思维训练。无需真实CT设备,不依赖活体动物,也能在电脑端反复练习CT操作流程、病历分析和报告书写。
              </p>
  
              <div class="flex flex-wrap gap-4 mb-10">
                <span class="bg-white px-4 py-2 rounded-lg shadow-sm border border-gray-100 flex items-center gap-2 text-sm font-medium text-gray-600">
                  <i data-lucide="monitor" class="w-4 h-4 text-brand-blue-600"></i> 零设备依赖
                </span>
                <span class="bg-white px-4 py-2 rounded-lg shadow-sm border border-gray-100 flex items-center gap-2 text-sm font-medium text-gray-600">
                  <i data-lucide="database" class="w-4 h-4 text-brand-blue-600"></i> 真实病历训练
                </span>
                <span class="bg-white px-4 py-2 rounded-lg shadow-sm border border-gray-100 flex items-center gap-2 text-sm font-medium text-gray-600">
                  <i data-lucide="brain-circuit" class="w-4 h-4 text-brand-blue-600"></i> AI评阅反馈
                </span>
                <span class="bg-white px-4 py-2 rounded-lg shadow-sm border border-gray-100 flex items-center gap-2 text-sm font-medium text-gray-600">
                  <i data-lucide="mouse-pointer-2" class="w-4 h-4 text-brand-blue-600"></i> 操作与诊断双系统
                </span>
              </div>
  
              <div class="flex flex-col sm:flex-row gap-4">
                <button @click="handleClick" class="bg-brand-blue-600 text-white px-8 py-4 rounded-xl font-bold text-lg hover:bg-brand-blue-700 transition-all flex items-center justify-center gap-2">
                  立即购买 <i data-lucide="arrow-right" class="w-5 h-5"></i>
                </button>
                <button @click="handleClick" class="bg-white border-2 border-brand-blue-600 text-brand-blue-600 px-8 py-4 rounded-xl font-bold text-lg hover:bg-brand-blue-50 transition-all">
                  查看价格方案
                </button>
                <button @click="handleClick" class="bg-gray-100 text-gray-700 px-8 py-4 rounded-xl font-bold text-lg hover:bg-gray-200 transition-all">
                  医院/机构咨询
                </button>
              </div>
            </div>
  
            <!-- 右侧视觉图 -->
            <div class="w-full lg:w-[45%] relative h-[500px]">
              <!-- 三层视觉叠加 -->
              <div class="absolute top-0 right-0 w-[85%] z-30 transform hover:scale-105 transition-transform duration-500">
                <div class="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100">
                  <div class="bg-gray-900 h-6 flex items-center px-3 gap-1.5">
                    <div class="w-2 h-2 rounded-full bg-red-500"></div>
                    <div class="w-2 h-2 rounded-full bg-yellow-500"></div>
                    <div class="w-2 h-2 rounded-full bg-green-500"></div>
                    <span class="text-[10px] text-gray-500 ml-2 font-mono uppercase">Diagnostic_Analysis.exe</span>
                  </div>
                  <img src="https://images.unsplash.com/photo-1579684385127-1ef15d508118?auto=format&fit=crop&w=800&q=80" alt="PACS阅片界面" class="w-full h-[280px] object-cover">
                  <div class="p-4 bg-gray-50 border-t border-gray-100">
                    <div class="flex justify-between items-center">
                      <div class="text-xs font-bold text-gray-400">PACS 病历库 / 阅片界面</div>
                      <div class="flex gap-2">
                        <div class="w-6 h-6 bg-blue-100 rounded text-blue-600 flex items-center justify-center"><i data-lucide="maximize" class="w-3 h-3"></i></div>
                        <div class="w-6 h-6 bg-blue-100 rounded text-blue-600 flex items-center justify-center"><i data-lucide="ruler" class="w-3 h-3"></i></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
              <div class="absolute top-20 right-20 w-[80%] z-20 opacity-90 transform -translate-x-12 translate-y-12">
                <div class="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
                  <img src="https://images.unsplash.com/photo-1516062423079-7ca13cdc7f5a?auto=format&fit=crop&w=800&q=80" alt="CT数字孪生" class="w-full h-[240px] object-cover filter grayscale-[0.5]">
                  <div class="p-3 bg-white text-[10px] text-gray-400 font-bold uppercase tracking-wider text-center">数字孪生操作场景截图</div>
                </div>
              </div>
  
              <div class="absolute bottom-0 right-40 w-[70%] z-10 opacity-70 transform -translate-x-24 translate-y-24">
                <div class="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100 p-6">
                  <div class="h-4 w-1/2 bg-gray-100 rounded mb-4"></div>
                  <div class="space-y-2">
                    <div class="h-3 w-full bg-gray-50 rounded"></div>
                    <div class="h-3 w-[90%] bg-gray-50 rounded"></div>
                    <div class="h-3 w-[80%] bg-gray-50 rounded"></div>
                  </div>
                  <div class="mt-6 flex justify-end">
                    <div class="h-8 w-24 bg-blue-50 rounded text-[10px] flex items-center justify-center text-blue-500 font-bold">AI评阅进行中</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  
      <!-- 03 产品总览区 -->
      <section class="py-24 bg-white">
        <div class="container-custom">
          <div class="text-center mb-16">
            <h2 class="text-4xl font-black text-brand-blue-900 mb-4">两个系统,覆盖宠物CT学习核心能力</h2>
            <p class="text-xl text-gray-500">从检查操作到诊断报告,帮助学员建立完整的宠物CT实训路径。</p>
          </div>
  
          <div class="grid lg:grid-cols-2 gap-10">
            <!-- 卡片一 -->
            <div class="bg-white rounded-[40px] p-10 border border-gray-100 shadow-xl shadow-gray-100/50 flex flex-col items-start card-hover">
              <span class="bg-blue-100 text-brand-blue-600 px-4 py-1 rounded-full text-sm font-bold mb-6">练操作</span>
              <h3 class="text-3xl font-bold text-brand-blue-900 mb-6">CT成像数字孪生系统实训</h3>
              <p class="text-gray-500 text-lg mb-8 leading-relaxed">
                通过虚拟CT检查场景,还原宠物CT检查全流程,训练设备巡检、动物接诊、麻醉监护、扫描摆位、参数设置、图像采集与后处理等操作能力。
              </p>
              <div class="grid grid-cols-2 gap-x-8 gap-y-3 mb-10 w-full">
                <div class="flex items-center gap-2 text-gray-600"><i data-lucide="check-circle-2" class="w-5 h-5 text-accent"></i> 设备日常巡检</div>
                <div class="flex items-center gap-2 text-gray-600"><i data-lucide="check-circle-2" class="w-5 h-5 text-accent"></i> 动物接诊准备</div>
                <div class="flex items-center gap-2 text-gray-600"><i data-lucide="check-circle-2" class="w-5 h-5 text-accent"></i> 麻醉诱导监护</div>
                <div class="flex items-center gap-2 text-gray-600"><i data-lucide="check-circle-2" class="w-5 h-5 text-accent"></i> 摆位与参数设置</div>
                <div class="flex items-center gap-2 text-gray-600"><i data-lucide="check-circle-2" class="w-5 h-5 text-accent"></i> CT图像采集</div>
                <div class="flex items-center gap-2 text-gray-600"><i data-lucide="check-circle-2" class="w-5 h-5 text-accent"></i> 图像后处理</div>
              </div>
              <button @click="handleClick" class="mt-auto w-full py-4 rounded-2xl bg-gray-50 text-brand-blue-600 font-bold hover:bg-brand-blue-50 transition-colors">了解操作实训</button>
            </div>
  
            <!-- 卡片二 -->
            <div class="bg-brand-blue-900 rounded-[40px] p-10 shadow-xl shadow-brand-blue-200/50 flex flex-col items-start card-hover">
              <span class="bg-white/10 text-white px-4 py-1 rounded-full text-sm font-bold mb-6">练诊断</span>
              <h3 class="text-3xl font-bold text-white mb-6">CT图像诊断思维训练系统</h3>
              <p class="text-brand-blue-100 text-lg mb-8 leading-relaxed">
                基于小动物真实CT/MR临床病历,提供病历调阅、影像分析、测量工具、报告书写、AI评阅和标准报告对照,训练完整影像诊断思维。
              </p>
              <div class="grid grid-cols-2 gap-x-8 gap-y-3 mb-10 w-full">
                <div class="flex items-center gap-2 text-brand-blue-100"><i data-lucide="check-circle-2" class="w-5 h-5 text-accent"></i> 1000+真实病历</div>
                <div class="flex items-center gap-2 text-brand-blue-100"><i data-lucide="check-circle-2" class="w-5 h-5 text-accent"></i> 专业测量工具</div>
                <div class="flex items-center gap-2 text-brand-blue-100"><i data-lucide="check-circle-2" class="w-5 h-5 text-accent"></i> MPR/3D 重建</div>
                <div class="flex items-center gap-2 text-brand-blue-100"><i data-lucide="check-circle-2" class="w-5 h-5 text-accent"></i> 诊断报告书写</div>
                <div class="flex items-center gap-2 text-brand-blue-100"><i data-lucide="check-circle-2" class="w-5 h-5 text-accent"></i> AI 智能评阅</div>
                <div class="flex items-center gap-2 text-brand-blue-100"><i data-lucide="check-circle-2" class="w-5 h-5 text-accent"></i> 标准报告对照</div>
              </div>
              <button @click="handleClick" class="mt-auto w-full py-4 rounded-2xl bg-white/10 text-white font-bold hover:bg-white/20 transition-colors">了解诊断训练</button>
            </div>
          </div>
        </div>
      </section>
  
      <!-- 04 用户痛点区 -->
      <section class="py-24 bg-light">
        <div class="container-custom">
          <h2 class="text-4xl font-black text-brand-blue-900 mb-16 text-center">宠物CT学习,难的不只是"看懂一张片"</h2>
          <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div class="bg-white p-8 rounded-3xl shadow-sm">
              <div class="w-14 h-14 bg-red-50 rounded-2xl flex items-center justify-center mb-6 text-red-500">
                <i data-lucide="wrench" class="w-8 h-8"></i>
              </div>
              <h4 class="text-xl font-bold mb-4">真实设备练习机会少</h4>
              <p class="text-gray-500 text-sm leading-relaxed">CT设备成本高,临床环境中很难让初学者反复练习完整操作流程。</p>
            </div>
            <div class="bg-white p-8 rounded-3xl shadow-sm">
              <div class="w-14 h-14 bg-orange-50 rounded-2xl flex items-center justify-center mb-6 text-orange-500">
                <i data-lucide="alert-triangle" class="w-8 h-8"></i>
              </div>
              <h4 class="text-xl font-bold mb-4">活体训练风险高</h4>
              <p class="text-gray-500 text-sm leading-relaxed">宠物CT涉及麻醉、摆位等环节,真实操作存在动物安全和医疗风险。</p>
            </div>
            <div class="bg-white p-8 rounded-3xl shadow-sm">
              <div class="w-14 h-14 bg-blue-50 rounded-2xl flex items-center justify-center mb-6 text-blue-500">
                <i data-lucide="hourglass" class="w-8 h-8"></i>
              </div>
              <h4 class="text-xl font-bold mb-4">病历积累周期长</h4>
              <p class="text-gray-500 text-sm leading-relaxed">影像诊断能力依赖大量病历,仅靠课堂学习很难快速形成系统思路。</p>
            </div>
            <div class="bg-white p-8 rounded-3xl shadow-sm">
              <div class="w-14 h-14 bg-green-50 rounded-2xl flex items-center justify-center mb-6 text-green-500">
                <i data-lucide="file-text" class="w-8 h-8"></i>
              </div>
              <h4 class="text-xl font-bold mb-4">报告书写不规范</h4>
              <p class="text-gray-500 text-sm leading-relaxed">很多医生能发现异常,但难以用规范术语和清晰结构完成高质量报告。</p>
            </div>
          </div>
        </div>
      </section>
  
      <!-- 05 功能详解一:CT成像数字孪生系统实训 -->
      <section id="features" class="py-24 bg-white scroll-mt">
        <div class="container-custom">
          <div class="flex flex-col lg:flex-row gap-20">
            <div class="w-full lg:w-1/2">
              <h2 class="text-4xl font-black text-brand-blue-900 mb-6">像在真实CT室一样,<br/>完成一次宠物CT检查训练</h2>
              <p class="text-xl text-gray-500 mb-12">从设备准备到动物复苏,完整模拟宠物CT检查流程,让高风险操作可以在虚拟环境中反复练习。</p>
  
              <!-- 流程图 -->
              <div class="relative space-y-4">
                <div class="flex items-center gap-6 group">
                  <div class="w-12 h-12 rounded-full bg-brand-blue-600 text-white flex items-center justify-center shrink-0 font-bold z-10 group-hover:scale-110 transition-transform">01</div>
                  <div class="flex-1 bg-gray-50 p-4 rounded-xl border border-gray-100 hover:border-brand-blue-200 transition-colors">
                    <h5 class="font-bold text-brand-blue-900">设备巡检与接诊</h5>
                    <p class="text-xs text-gray-400 mt-1">登录系统、球管预热、空气校正、动物接诊</p>
                  </div>
                </div>
                <div class="flex items-center gap-6 group">
                  <div class="w-12 h-12 rounded-full bg-brand-blue-600 text-white flex items-center justify-center shrink-0 font-bold z-10 group-hover:scale-110 transition-transform">02</div>
                  <div class="flex-1 bg-gray-50 p-4 rounded-xl border border-gray-100 hover:border-brand-blue-200 transition-colors">
                    <h5 class="font-bold text-brand-blue-900">临床操作模拟</h5>
                    <p class="text-xs text-gray-400 mt-1">麻醉诱导、气管插管、扫描摆位、体征监控</p>
                  </div>
                </div>
                <div class="flex items-center gap-6 group">
                  <div class="w-12 h-12 rounded-full bg-brand-blue-600 text-white flex items-center justify-center shrink-0 font-bold z-10 group-hover:scale-110 transition-transform">03</div>
                  <div class="flex-1 bg-gray-50 p-4 rounded-xl border border-gray-100 hover:border-brand-blue-200 transition-colors">
                    <h5 class="font-bold text-brand-blue-900">扫描与后处理</h5>
                    <p class="text-xs text-gray-400 mt-1">参数设定、影像采集、图像窗宽窗位调节</p>
                  </div>
                </div>
                <!-- 连接线 -->
                <div class="absolute top-6 bottom-6 left-[23px] w-0.5 bg-brand-blue-100 -z-0"></div>
              </div>
            </div>
  
            <div class="w-full lg:w-1/2 grid grid-cols-1 md:grid-cols-2 gap-6">
              <div class="p-6 rounded-3xl bg-blue-50/50 border border-blue-100">
                <i data-lucide="layers" class="w-10 h-10 text-brand-blue-600 mb-4"></i>
                <h5 class="text-lg font-bold mb-2">全真虚拟场景</h5>
                <p class="text-sm text-gray-500 leading-relaxed">构建药物准备区、麻醉监控区等,还原宠物CT检查真实工作空间。</p>
              </div>
              <div class="p-6 rounded-3xl bg-blue-50/50 border border-blue-100">
                <i data-lucide="list-checks" class="w-10 h-10 text-brand-blue-600 mb-4"></i>
                <h5 class="text-lg font-bold mb-2">标准化流程引导</h5>
                <p class="text-sm text-gray-500 leading-relaxed">围绕SOP关键步骤,帮助学员掌握规范的CT检查操作流程。</p>
              </div>
              <div class="p-6 rounded-3xl bg-blue-50/50 border border-blue-100">
                <i data-lucide="activity" class="w-10 h-10 text-brand-blue-600 mb-4"></i>
                <h5 class="text-lg font-bold mb-2">生命体征联动</h5>
                <p class="text-sm text-gray-500 leading-relaxed">设置会影响图像质量和体征,加深对临床操作与结果之间关系的理解。</p>
              </div>
              <div class="p-6 rounded-3xl bg-blue-50/50 border border-blue-100">
                <i data-lucide="refresh-cw" class="w-10 h-10 text-brand-blue-600 mb-4"></i>
                <h5 class="text-lg font-bold mb-2">低成本重复训练</h5>
                <p class="text-sm text-gray-500 leading-relaxed">复杂、高风险操作可多次练习,极大降低真实临床环境试错成本。</p>
              </div>
            </div>
          </div>
        </div>
      </section>
  
      <!-- 06 功能详解二:CT图像诊断思维训练系统 -->
      <section class="py-24 bg-light">
        <div class="container-custom">
          <div class="flex flex-col lg:flex-row-reverse gap-20 items-center">
            <div class="w-full lg:w-1/2">
              <h2 class="text-4xl font-black text-brand-blue-900 mb-6">从病历调阅到报告书写,<br/>训练完整影像诊断思维</h2>
              <p class="text-xl text-gray-500 mb-12">不是单纯看病历,而是让学员完成"阅片、分析、诊断、写报告、接受评价"的完整训练闭环。</p>
  
              <div class="space-y-8">
                <div class="flex gap-4">
                  <div class="bg-white p-3 rounded-2xl shadow-sm h-fit">
                    <i data-lucide="database" class="w-6 h-6 text-brand-blue-600"></i>
                  </div>
                  <div>
                    <h5 class="text-xl font-bold text-brand-blue-900 mb-2">真实病历库 (1000+)</h5>
                    <p class="text-gray-500">内置海量小动物真实 CT/MR 临床病历,覆盖多部位、多疾病类型,满足系统化训练。</p>
                  </div>
                </div>
                <div class="flex gap-4">
                  <div class="bg-white p-3 rounded-2xl shadow-sm h-fit">
                    <i data-lucide="box" class="w-6 h-6 text-brand-blue-600"></i>
                  </div>
                  <div>
                    <h5 class="text-xl font-bold text-brand-blue-900 mb-2">多维影像分析工具</h5>
                    <p class="text-gray-500">提供 CT值/长度测量、MPR多平面重建、MIP最大密度投影及3D可视化重建工具。</p>
                  </div>
                </div>
                <div class="flex gap-4">
                  <div class="bg-white p-3 rounded-2xl shadow-sm h-fit">
                    <i data-lucide="sparkles" class="w-6 h-6 text-brand-blue-600"></i>
                  </div>
                  <div>
                    <h5 class="text-xl font-bold text-brand-blue-900 mb-2">AI 智能评阅反馈</h5>
                    <p class="text-gray-500">从描述完整性、术语准确性、逻辑严密性等维度对报告评分,即刻获得改进方向。</p>
                  </div>
                </div>
              </div>
            </div>
  
            <div class="w-full lg:w-1/2">
              <div class="relative bg-gray-900 rounded-[32px] p-2 shadow-2xl overflow-hidden aspect-[4/3] group">
                <img src="https://images.unsplash.com/photo-1530210124550-912dc1381cb8?auto=format&fit=crop&w=1200&q=80" alt="PACS系统界面" class="w-full h-full object-cover rounded-[28px] opacity-80 group-hover:scale-105 transition-transform duration-700">
                <div class="absolute inset-0 bg-gradient-to-t from-gray-900 via-transparent to-transparent flex flex-col justify-end p-10">
                  <div class="flex items-center gap-3 mb-4">
                    <div class="px-3 py-1 bg-brand-blue-600 rounded text-xs font-bold text-white uppercase tracking-widest">Training Loop</div>
                  </div>
                  <h4 class="text-2xl font-bold text-white mb-2">训练闭环流程</h4>
                  <div class="flex flex-wrap gap-2">
                    <span class="bg-white/10 backdrop-blur-md px-3 py-1.5 rounded-lg text-xs text-brand-blue-100 border border-white/10">病历调阅</span>
                    <span class="bg-white/10 backdrop-blur-md px-3 py-1.5 rounded-lg text-xs text-brand-blue-100 border border-white/10">独立阅片</span>
                    <span class="bg-white/10 backdrop-blur-md px-3 py-1.5 rounded-lg text-xs text-brand-blue-100 border border-white/10">影像测量</span>
                    <span class="bg-white/10 backdrop-blur-md px-3 py-1.5 rounded-lg text-xs text-brand-blue-100 border border-white/10">诊断分析</span>
                    <span class="bg-white/10 backdrop-blur-md px-3 py-1.5 rounded-lg text-xs text-brand-blue-100 border border-white/10">报告书写</span>
                    <span class="bg-white/10 backdrop-blur-md px-3 py-1.5 rounded-lg text-xs text-brand-blue-100 border border-white/10">AI评阅</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  
      <!-- 07 使用场景区 -->
      <section id="users" class="py-24 bg-white scroll-mt">
        <div class="container-custom">
          <h2 class="text-4xl font-black text-brand-blue-900 mb-16 text-center">适用于个人提升、医院培训与机构教学</h2>
          <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div class="flex flex-col h-full bg-white rounded-3xl border border-gray-100 p-8 card-hover">
              <h5 class="text-xl font-bold mb-4 flex items-center gap-2"><i data-lucide="user" class="text-blue-500"></i> 个人医生提升</h5>
              <div class="text-sm text-gray-400 mb-6 italic">临床医生、实习生</div>
              <ul class="space-y-3 mb-8 flex-1">
                <li class="text-gray-500 text-sm flex items-start gap-2"><i data-lucide="check" class="w-4 h-4 text-accent mt-0.5"></i> 学习CT操作全流程</li>
                <li class="text-gray-500 text-sm flex items-start gap-2"><i data-lucide="check" class="w-4 h-4 text-accent mt-0.5"></i> 规范诊断报告书写</li>
                <li class="text-gray-500 text-sm flex items-start gap-2"><i data-lucide="check" class="w-4 h-4 text-accent mt-0.5"></i> 积累海量病历经验</li>
              </ul>
              <div class="bg-blue-50 p-4 rounded-xl text-xs text-brand-blue-600 font-bold">推荐:诊断思维训练系统</div>
            </div>
  
            <div class="flex flex-col h-full bg-white rounded-3xl border border-gray-100 p-8 card-hover">
              <h5 class="text-xl font-bold mb-4 flex items-center gap-2"><i data-lucide="hospital" class="text-blue-500"></i> 宠物医院内训</h5>
              <div class="text-sm text-gray-400 mb-6 italic">影像科人才建设</div>
              <ul class="space-y-3 mb-8 flex-1">
                <li class="text-gray-500 text-sm flex items-start gap-2"><i data-lucide="check" class="w-4 h-4 text-accent mt-0.5"></i> 降低新人实操风险</li>
                <li class="text-gray-500 text-sm flex items-start gap-2"><i data-lucide="check" class="w-4 h-4 text-accent mt-0.5"></i> 统一规范检查流程</li>
                <li class="text-gray-500 text-sm flex items-start gap-2"><i data-lucide="check" class="w-4 h-4 text-accent mt-0.5"></i> 提升影像报告质量</li>
              </ul>
              <div class="bg-blue-50 p-4 rounded-xl text-xs text-brand-blue-600 font-bold">推荐:打包产品</div>
            </div>
  
            <div class="flex flex-col h-full bg-white rounded-3xl border border-gray-100 p-8 card-hover">
              <h5 class="text-xl font-bold mb-4 flex items-center gap-2"><i data-lucide="graduation-cap" class="text-blue-500"></i> 院校实训教学</h5>
              <div class="text-sm text-gray-400 mb-6 italic">动医相关专业</div>
              <ul class="space-y-3 mb-8 flex-1">
                <li class="text-gray-500 text-sm flex items-start gap-2"><i data-lucide="check" class="w-4 h-4 text-accent mt-0.5"></i> 补充影像实训条件</li>
                <li class="text-gray-500 text-sm flex items-start gap-2"><i data-lucide="check" class="w-4 h-4 text-accent mt-0.5"></i> 解决活体训练限制</li>
                <li class="text-gray-500 text-sm flex items-start gap-2"><i data-lucide="check" class="w-4 h-4 text-accent mt-0.5"></i> 数字化教学考核</li>
              </ul>
              <div class="bg-blue-50 p-4 rounded-xl text-xs text-brand-blue-600 font-bold">推荐:机构定制采购</div>
            </div>
  
            <div class="flex flex-col h-full bg-white rounded-3xl border border-gray-100 p-8 card-hover">
              <h5 class="text-xl font-bold mb-4 flex items-center gap-2"><i data-lucide="book-open" class="text-blue-500"></i> 培训机构配套</h5>
              <div class="text-sm text-gray-400 mb-6 italic">课程与继续教育</div>
              <ul class="space-y-3 mb-8 flex-1">
                <li class="text-gray-500 text-sm flex items-start gap-2"><i data-lucide="check" class="w-4 h-4 text-accent mt-0.5"></i> 课程+练习+考核闭环</li>
                <li class="text-gray-500 text-sm flex items-start gap-2"><i data-lucide="check" class="w-4 h-4 text-accent mt-0.5"></i> 提高课程实操体验</li>
                <li class="text-gray-500 text-sm flex items-start gap-2"><i data-lucide="check" class="w-4 h-4 text-accent mt-0.5"></i> 丰富训练病历资源</li>
              </ul>
              <div class="bg-blue-50 p-4 rounded-xl text-xs text-brand-blue-600 font-bold">推荐:打包产品/合作</div>
            </div>
          </div>
        </div>
      </section>
  
      <!-- 08 产品优势区 -->
      <section class="py-24 bg-brand-blue-900 text-white">
        <div class="container-custom">
          <h2 class="text-4xl font-black mb-16 text-center">让宠物CT训练更安全、更标准、更可重复</h2>
          <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
            <div class="flex gap-6">
              <div class="shrink-0 w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center text-accent"><i data-lucide="trending-down" class="w-6 h-6"></i></div>
              <div>
                <h6 class="text-lg font-bold mb-2">降低实训成本</h6>
                <p class="text-sm text-brand-blue-100 opacity-80 leading-relaxed">无需购买昂贵设备,无耗材投入,适合长期反复使用。</p>
              </div>
            </div>
            <div class="flex gap-6">
              <div class="shrink-0 w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center text-accent"><i data-lucide="shield-check" class="w-6 h-6"></i></div>
              <div>
                <h6 class="text-lg font-bold mb-2">降低动物风险</h6>
                <p class="text-sm text-brand-blue-100 opacity-80 leading-relaxed">虚拟环境练习,零动物安全风险,大幅减少临床操作焦虑。</p>
              </div>
            </div>
            <div class="flex gap-6">
              <div class="shrink-0 w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center text-accent"><i data-lucide="workflow" class="w-6 h-6"></i></div>
              <div>
                <h6 class="text-lg font-bold mb-2">训练流程完整</h6>
                <p class="text-sm text-brand-blue-100 opacity-80 leading-relaxed">从操作到麻醉监控再到阅片评价,实现全链路实训覆盖。</p>
              </div>
            </div>
            <div class="flex gap-6">
              <div class="shrink-0 w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center text-accent"><i data-lucide="file-search" class="w-6 h-6"></i></div>
              <div>
                <h6 class="text-lg font-bold mb-2">真实病历丰富</h6>
                <p class="text-sm text-brand-blue-100 opacity-80 leading-relaxed">多病种、多部位真实影像,帮助学员积累扎实阅片经验。</p>
              </div>
            </div>
            <div class="flex gap-6">
              <div class="shrink-0 w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center text-accent"><i data-lucide="message-square-more" class="w-6 h-6"></i></div>
              <div>
                <h6 class="text-lg font-bold mb-2">反馈更加清晰</h6>
                <p class="text-sm text-brand-blue-100 opacity-80 leading-relaxed">AI 智能评分机制,明确优缺点,提供针对性复盘提升建议。</p>
              </div>
            </div>
            <div class="flex gap-6">
              <div class="shrink-0 w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center text-accent"><i data-lucide="laptop" class="w-6 h-6"></i></div>
              <div>
                <h6 class="text-lg font-bold mb-2">电脑端在线使用</h6>
                <p class="text-sm text-brand-blue-100 opacity-80 leading-relaxed">无需安装,专业界面深度适配阅片与测量操作习惯。</p>
              </div>
            </div>
          </div>
        </div>
      </section>
  
      <!-- 09 价格方案区 -->
      <section id="pricing" class="py-32 bg-light scroll-mt">
        <div class="container-custom">
          <div class="text-center mb-20">
            <h2 class="text-4xl font-black text-brand-blue-900 mb-4">选择适合你的训练方案</h2>
            <p class="text-xl text-gray-500">可单独购买或选择打包产品,完整训练宠物CT核心能力。</p>
          </div>
  
          <div class="grid lg:grid-cols-3 items-center max-w-[1200px] mx-auto">
            <!-- 方案一 -->
            <div class="bg-white rounded-l-[40px] p-10 border-y border-l border-gray-100 flex flex-col items-center text-center shadow-sm">
              <span class="bg-gray-100 text-gray-500 px-4 py-1 rounded-full text-xs font-bold mb-6">练CT操作流程</span>
              <h4 class="text-xl font-bold mb-2">CT成像数字孪生系统</h4>
              <p class="text-sm text-gray-400 mb-8 px-6">适合学习设备操作、扫描流程、摆位和参数设置。</p>
              <div class="space-y-4 w-full mb-10">
                <div class="flex justify-between items-center text-sm"><span class="text-gray-500">1个月</span> <span class="font-bold text-gray-900">188元</span></div>
                <div class="flex justify-between items-center text-sm"><span class="text-gray-500">3个月</span> <span class="font-bold text-gray-900">328元</span></div>
                <div class="flex justify-between items-center text-sm border-t border-gray-50 pt-4"><span class="text-gray-500 font-bold uppercase tracking-tighter">半年期</span> <span class="text-xl font-black text-brand-blue-600">598元</span></div>
              </div>
              <button @click="handleClick" class="w-full py-4 rounded-2xl bg-gray-100 text-gray-600 font-bold hover:bg-gray-200 transition-colors mt-auto">购买操作实训</button>
            </div>
  
            <!-- 方案二 (推荐) -->
            <div class="bg-white rounded-[40px] p-12 border-2 border-brand-blue-600 flex flex-col items-center text-center shadow-2xl relative z-10 scale-110">
              <div class="absolute -top-5 bg-brand-blue-600 text-white px-6 py-2 rounded-full text-sm font-black shadow-lg">推荐:系统化学习</div>
              <span class="bg-brand-blue-50 text-brand-blue-600 px-4 py-1 rounded-full text-xs font-bold mb-6">操作 + 诊断完整训练</span>
              <h4 class="text-2xl font-bold mb-2 text-brand-blue-900">打包产品方案</h4>
              <p class="text-sm text-gray-400 mb-8 px-6">包含双系统全部功能,适合零基础至进阶的系统化培养。</p>
              <div class="space-y-4 w-full mb-12">
                <div class="flex justify-between items-center text-sm"><span class="text-gray-500">1个月</span> <span class="font-bold text-gray-900">288元</span></div>
                <div class="flex justify-between items-center text-sm"><span class="text-gray-500">3个月</span> <span class="font-bold text-gray-900">528元</span></div>
                <div class="flex justify-between items-center text-sm border-t border-brand-blue-50 pt-4"><span class="text-gray-900 font-black uppercase tracking-tighter">半年期</span> <span class="text-3xl font-black text-brand-blue-600">888元</span></div>
              </div>
              <button @click="handleClick" class="w-full py-5 rounded-2xl bg-brand-blue-600 text-white font-bold hover:bg-brand-blue-700 transition-all shadow-xl shadow-brand-blue-200 mt-auto">购买打包产品</button>
              <p class="text-[10px] text-gray-400 mt-6">一次性掌握操作技巧与阅片思维</p>
            </div>
  
            <!-- 方案三 -->
            <div class="bg-white rounded-r-[40px] p-10 border-y border-r border-gray-100 flex flex-col items-center text-center shadow-sm">
              <span class="bg-gray-100 text-gray-500 px-4 py-1 rounded-full text-xs font-bold mb-6">练阅片诊断与报告</span>
              <h4 class="text-xl font-bold mb-2">诊断思维训练系统</h4>
              <p class="text-sm text-gray-400 mb-8 px-6">提升病历调阅、影像分析及报告书写能力。</p>
              <div class="space-y-4 w-full mb-10">
                <div class="flex justify-between items-center text-sm font-bold text-accent"><span class="">3天体验 (限时)</span> <span class="">9.9元</span></div>
                <div class="flex justify-between items-center text-sm"><span class="text-gray-500">1个月</span> <span class="font-bold text-gray-900">128元</span></div>
                <div class="flex justify-between items-center text-sm border-t border-gray-50 pt-4"><span class="text-gray-500 font-bold uppercase tracking-tighter">1年期</span> <span class="text-xl font-black text-brand-blue-600">698元</span></div>
              </div>
              <button @click="handleClick" class="w-full py-4 rounded-2xl bg-gray-100 text-gray-600 font-bold hover:bg-gray-200 transition-colors mt-auto">购买诊断训练</button>
            </div>
          </div>
  
          <p class="text-center text-gray-400 text-sm mt-16 max-w-2xl mx-auto italic">
            * 购买后即可在有效期内登录电脑端使用。医院、院校、培训机构如需批量采购或定制合作,请点击下方机构专区咨询。
          </p>
        </div>
      </section>
  
      <!-- 10 决策引导区 -->
      <section class="py-24 bg-white">
        <div class="container-custom">
          <h2 class="text-3xl font-black text-brand-blue-900 mb-12 text-center">不知道选哪个?按学习目标选择</h2>
          <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div class="p-8 rounded-3xl bg-white border-2 border-gray-50 hover:border-brand-blue-100 transition-colors text-center group">
              <div class="w-12 h-12 bg-blue-50 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform"><i data-lucide="zap" class="w-6 h-6"></i></div>
              <h6 class="font-bold mb-4 text-gray-900">我想先体验一下</h6>
              <p class="text-xs text-gray-400 leading-relaxed mb-6">适合初次了解产品,想先看病历和报告评阅效果。</p>
              <div class="text-sm font-bold text-brand-blue-600 underline">诊断训练 3天体验版</div>
            </div>
            <div class="p-8 rounded-3xl bg-white border-2 border-gray-50 hover:border-brand-blue-100 transition-colors text-center group">
              <div class="w-12 h-12 bg-blue-50 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform"><i data-lucide="settings" class="w-6 h-6"></i></div>
              <h6 class="font-bold mb-4 text-gray-900">我想练CT检查操作</h6>
              <p class="text-xs text-gray-400 leading-relaxed mb-6">适合重点学习设备操作、扫描摆位和临床检查流程。</p>
              <div class="text-sm font-bold text-brand-blue-600 underline">数字孪生操作实训</div>
            </div>
            <div class="p-8 rounded-3xl bg-white border-2 border-gray-50 hover:border-brand-blue-100 transition-colors text-center group">
              <div class="w-12 h-12 bg-blue-50 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform"><i data-lucide="eye" class="w-6 h-6"></i></div>
              <h6 class="font-bold mb-4 text-gray-900">我想提升阅片能力</h6>
              <p class="text-xs text-gray-400 leading-relaxed mb-6">想积累海量病历,提升影像诊断思维,规范书写报告。</p>
              <div class="text-sm font-bold text-brand-blue-600 underline">诊断思维训练系统</div>
            </div>
            <div class="p-8 rounded-3xl bg-white border-2 border-gray-50 hover:border-brand-blue-100 transition-colors text-center group">
              <div class="w-12 h-12 bg-blue-50 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform"><i data-lucide="layout" class="w-6 h-6"></i></div>
              <h6 class="font-bold mb-4 text-gray-900">我想系统学习宠物CT</h6>
              <p class="text-xs text-gray-400 leading-relaxed mb-6">医生、医院和教学机构的最佳选择,全能型实训方案。</p>
              <div class="text-sm font-bold text-brand-blue-600 underline">打包产品推荐方案</div>
            </div>
          </div>
        </div>
      </section>
  
      <!-- 11 产品使用流程区 -->
      <section class="py-24 bg-light">
        <div class="container-custom">
          <h2 class="text-4xl font-black text-brand-blue-900 mb-20 text-center">购买后即可开始电脑端训练</h2>
          <div class="relative max-w-[1000px] mx-auto">
            <div class="grid md:grid-cols-5 gap-4 relative z-10">
              <div class="flex flex-col items-center text-center">
                <div class="w-16 h-16 rounded-2xl bg-brand-blue-600 text-white flex items-center justify-center mb-6 shadow-lg shadow-brand-blue-200">
                  <i data-lucide="shopping-cart" class="w-8 h-8"></i>
                </div>
                <h6 class="font-bold text-sm mb-2 text-gray-900">第一步:购买</h6>
                <p class="text-[10px] text-gray-500">选择产品与时长<br/>在线支付完成购买</p>
              </div>
              <div class="flex flex-col items-center text-center">
                <div class="w-16 h-16 rounded-2xl bg-white border-2 border-brand-blue-100 text-brand-blue-600 flex items-center justify-center mb-6">
                  <i data-lucide="log-in" class="w-8 h-8"></i>
                </div>
                <h6 class="font-bold text-sm mb-2 text-gray-900">第二步:进入</h6>
                <p class="text-[10px] text-gray-500">登录宠医客平台<br/>进入实训系统</p>
              </div>
              <div class="flex flex-col items-center text-center">
                <div class="w-16 h-16 rounded-2xl bg-white border-2 border-brand-blue-100 text-brand-blue-600 flex items-center justify-center mb-6">
                  <i data-lucide="mouse" class="w-8 h-8"></i>
                </div>
                <h6 class="font-bold text-sm mb-2 text-gray-900">第三步:选择</h6>
                <p class="text-[10px] text-gray-500">选择操作实训<br/>或诊断思维训练</p>
              </div>
              <div class="flex flex-col items-center text-center">
                <div class="w-16 h-16 rounded-2xl bg-white border-2 border-brand-blue-100 text-brand-blue-600 flex items-center justify-center mb-6">
                  <i data-lucide="play-circle" class="w-8 h-8"></i>
                </div>
                <h6 class="font-bold text-sm mb-2 text-gray-900">第四步:训练</h6>
                <p class="text-[10px] text-gray-500">完成模拟操作、阅片<br/>或诊断报告书写</p>
              </div>
              <div class="flex flex-col items-center text-center">
                <div class="w-16 h-16 rounded-2xl bg-accent text-white flex items-center justify-center mb-6">
                  <i data-lucide="award" class="w-8 h-8"></i>
                </div>
                <h6 class="font-bold text-sm mb-2 text-gray-900">第五步:提升</h6>
                <p class="text-[10px] text-gray-500">查看 AI 反馈结果<br/>对照标准报告复盘</p>
              </div>
            </div>
            <!-- 连接线 -->
            <div class="absolute top-8 left-0 right-0 h-0.5 bg-brand-blue-50 -z-0 hidden md:block"></div>
          </div>
        </div>
      </section>
  
      <!-- 12 机构采购专区 -->
      <section class="py-24 bg-white">
        <div class="container-custom">
          <div class="bg-brand-blue-50 rounded-[60px] p-16 flex flex-col items-center text-center">
            <h2 class="text-4xl font-black text-brand-blue-900 mb-4">医院、院校、培训机构可咨询批量采购</h2>
            <p class="text-xl text-brand-blue-600/70 mb-16 max-w-3xl">支持用于宠物医院影像人才培养、动物医学专业实训教学、影像培训课程配套与考核管理。</p>
  
            <div class="grid md:grid-cols-3 gap-8 w-full">
              <div class="bg-white p-10 rounded-3xl shadow-sm border border-brand-blue-100 flex flex-col items-center">
                <div class="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center mb-6 text-brand-blue-600">
                  <i data-lucide="building-2" class="w-7 h-7"></i>
                </div>
                <h5 class="text-xl font-bold mb-4">宠物医院</h5>
                <p class="text-sm text-gray-400 mb-8 leading-relaxed">用于影像科医生培养、CT流程规范、新人实训和报告规范训练。</p>
                <button @click="handleClick" class="px-8 py-3 bg-brand-blue-600 text-white rounded-xl font-bold hover:bg-brand-blue-700 transition-colors text-sm">咨询医院采购</button>
              </div>
              <div class="bg-white p-10 rounded-3xl shadow-sm border border-brand-blue-100 flex flex-col items-center">
                <div class="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center mb-6 text-brand-blue-600">
                  <i data-lucide="graduation-cap" class="w-7 h-7"></i>
                </div>
                <h5 class="text-xl font-bold mb-4">院校机构</h5>
                <p class="text-sm text-gray-400 mb-8 leading-relaxed">用于动医专业实训课、实验课考核。形成数字化教学记录。</p>
                <button @click="handleClick" class="px-8 py-3 bg-brand-blue-600 text-white rounded-xl font-bold hover:bg-brand-blue-700 transition-colors text-sm">咨询院校合作</button>
              </div>
              <div class="bg-white p-10 rounded-3xl shadow-sm border border-brand-blue-100 flex flex-col items-center">
                <div class="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center mb-6 text-brand-blue-600">
                  <i data-lucide="users-2" class="w-7 h-7"></i>
                </div>
                <h5 class="text-xl font-bold mb-4">培训机构</h5>
                <p class="text-sm text-gray-400 mb-8 leading-relaxed">用于课程配套,丰富训练病历资源,提升培训产品专业度。</p>
                <button @click="handleClick" class="px-8 py-3 bg-brand-blue-600 text-white rounded-xl font-bold hover:bg-brand-blue-700 transition-colors text-sm">咨询培训合作</button>
              </div>
            </div>
          </div>
        </div>
      </section>
  
      <!-- 13 常见问题区 -->
      <section id="faq" class="py-24 bg-white scroll-mt">
        <div class="container-custom max-w-[900px]">
          <h2 class="text-3xl font-black text-brand-blue-900 mb-12 text-center">常见问题</h2>
          <div class="space-y-6">
            <div class="border-b border-gray-100 pb-6">
              <h6 class="font-bold text-lg mb-3 flex items-center gap-3"><i data-lucide="help-circle" class="text-brand-blue-600 w-5 h-5"></i> 这个产品需要安装软件吗?</h6>
              <p class="text-gray-500 pl-8 leading-relaxed">不需要。产品为电脑端在线使用,用户可通过宠医客平台进入对应系统。</p>
            </div>
            <div class="border-b border-gray-100 pb-6">
              <h6 class="font-bold text-lg mb-3 flex items-center gap-3"><i data-lucide="help-circle" class="text-brand-blue-600 w-5 h-5"></i> 没有真实CT设备基础,可以学习吗?</h6>
              <p class="text-gray-500 pl-8 leading-relaxed">可以。CT成像数字孪生系统实训会通过虚拟场景和流程引导,帮助用户了解宠物CT检查的基础流程。</p>
            </div>
            <div class="border-b border-gray-100 pb-6">
              <h6 class="font-bold text-lg mb-3 flex items-center gap-3"><i data-lucide="help-circle" class="text-brand-blue-600 w-5 h-5"></i> 诊断训练系统中的病历是真实病历吗?</h6>
              <p class="text-gray-500 pl-8 leading-relaxed">是。系统内置小动物真实CT/MR临床病历,支持病历调阅、阅片分析和报告书写训练。</p>
            </div>
            <div class="border-b border-gray-100 pb-6">
              <h6 class="font-bold text-lg mb-3 flex items-center gap-3"><i data-lucide="help-circle" class="text-brand-blue-600 w-5 h-5"></i> AI评阅能替代老师吗?</h6>
              <p class="text-gray-500 pl-8 leading-relaxed">AI评阅可帮助用户快速获得报告反馈,发现描述、术语和逻辑问题。机构教学场景下,也可结合教师人工批改使用。</p>
            </div>
          </div>
        </div>
      </section>
  
      <!-- 14 底部转化区 -->
      <section class="py-24 bg-brand-blue-900 text-white">
        <div class="container-custom text-center">
          <h2 class="text-5xl font-black mb-8">现在开始宠物CT影像实训</h2>
          <p class="text-xl text-brand-blue-100 mb-12 max-w-3xl mx-auto opacity-80">
            从CT检查操作到影像诊断报告,建立更完整、更标准、更可重复的宠物CT训练路径。
          </p>
          <div class="flex flex-wrap justify-center gap-6">
            <button @click="handleClick" class="px-12 py-5 bg-white text-brand-blue-900 font-black rounded-2xl hover:bg-brand-blue-50 transition-all text-xl shadow-2xl">立即购买</button>
            <button @click="handleClick" class="px-10 py-5 bg-white/10 text-white font-bold rounded-2xl hover:bg-white/20 transition-all text-lg border border-white/10">咨询机构采购</button>
          </div>
  
          <div class="mt-24 pt-12 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-8 text-sm text-brand-blue-200 opacity-60">
            <div class="flex items-center gap-2">
              <div class="w-8 h-8 bg-white/10 rounded flex items-center justify-center font-bold">宠</div>
              <span>© 2024 宠医客版权所有</span>
            </div>
            <div class="flex gap-8">
              <a href="#" @click.prevent="handleClick" class="hover:text-white transition-colors">服务协议</a>
              <a href="#" @click.prevent="handleClick" class="hover:text-white transition-colors">隐私条款</a>
              <a href="#" @click.prevent="handleClick" class="hover:text-white transition-colors">联系我们</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PetCTTraining',
    mounted() {
      // 初始化 Lucide 图标
      this.$nextTick(() => {
        if (window.lucide) {
          window.lucide.createIcons()
        }
      })
    },
    methods: {
      handleClick() {
        // 空点击事件
      }
    }
  }
  </script>
  
  <style>
  .pet-ct-training {
    font-family: 'Inter', 'Microsoft YaHei', sans-serif;
    color: #1F2937;
    overflow-x: hidden;
  }
  
  .pet-ct-training html {
    scroll-behavior: smooth;
  }
  
  .pet-ct-training .container-custom {
    max-width: 1440px;
    margin: 0 auto;
    padding: 0 40px;
  }
  
  .pet-ct-training .glass-nav {
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(10px);
  }
  
  .pet-ct-training .hero-gradient {
    background: linear-gradient(135deg, #F0F7FF 0%, #FFFFFF 100%);
  }
  
  .pet-ct-training .card-hover:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
  }
  
  .pet-ct-training .scroll-mt {
    scroll-margin-top: 80px;
  }
  
  /* Tailwind CSS 自定义颜色 */
  .pet-ct-training .bg-brand-blue-600 {
    background-color: #2563eb;
  }
  
  .pet-ct-training .text-brand-blue-600 {
    color: #2563eb;
  }
  
  .pet-ct-training .text-brand-blue-900 {
    color: #1e3a8a;
  }
  
  .pet-ct-training .bg-brand-blue-900 {
    background-color: #1e3a8a;
  }
  
  .pet-ct-training .text-brand-blue-100 {
    color: #dbeafe;
  }
  
  .pet-ct-training .bg-brand-blue-50 {
    background-color: #eff6ff;
  }
  
  .pet-ct-training .hover\:bg-brand-blue-700:hover {
    background-color: #1d4ed8;
  }
  
  .pet-ct-training .hover\:bg-brand-blue-50:hover {
    background-color: #eff6ff;
  }
  
  .pet-ct-training .border-brand-blue-600 {
    border-color: #2563eb;
  }
  
  .pet-ct-training .border-brand-blue-200 {
    border-color: #bfdbfe;
  }
  
  .pet-ct-training .border-brand-blue-100 {
    border-color: #dbeafe;
  }
  
  .pet-ct-training .shadow-brand-blue-200 {
    --tw-shadow-color: #bfdbfe;
  }
  
  .pet-ct-training .bg-blue-100 {
    background-color: #dbeafe;
  }
  
  .pet-ct-training .bg-blue-50 {
    background-color: #eff6ff;
  }
  
  .pet-ct-training .text-blue-500 {
    color: #3b82f6;
  }
  
  .pet-ct-training .text-blue-600 {
    color: #2563eb;
  }
  
  .pet-ct-training .bg-accent {
    background-color: #10B981;
  }
  
  .pet-ct-training .text-accent {
    color: #10B981;
  }
  
  .pet-ct-training .bg-light {
    background-color: #F3F4F6;
  }
  
  .pet-ct-training .border-brand-blue-50 {
    border-color: #eff6ff;
  }
  
  .pet-ct-training .hover\:border-brand-blue-100:hover {
    border-color: #dbeafe;
  }
  
  .pet-ct-training .hover\:border-brand-blue-200:hover {
    border-color: #bfdbfe;
  }
  
  .pet-ct-training .shadow-brand-blue-100\/50 {
    --tw-shadow-color: rgba(219, 234, 254, 0.5);
  }
  
  .pet-ct-training .bg-white\/10 {
    background-color: rgba(255, 255, 255, 0.1);
  }
  
  .pet-ct-training .bg-white\/20 {
    background-color: rgba(255, 255, 255, 0.2);
  }
  
  .pet-ct-training .border-white\/10 {
    border-color: rgba(255, 255, 255, 0.1);
  }
  
  .pet-ct-training .bg-brand-blue-600\/70 {
    background-color: rgba(37, 99, 235, 0.7);
  }
  
  .pet-ct-training .text-brand-blue-200 {
    color: #bfdbfe;
  }
  
  .pet-ct-training .bg-blue-50\/50 {
    background-color: rgba(239, 246, 255, 0.5);
  }
  
  .pet-ct-training .bg-brand-blue-100 {
    background-color: #dbeafe;
  }
  
  .pet-ct-training .filter.grayscale-\[0\.5\] {
    --tw-grayscale: grayscale(0.5);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  }
  
  .pet-ct-training .backdrop-blur-md {
    --tw-backdrop-blur: blur(12px);
    -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  }
  </style>
  